import { mapState, mapActions, mapMutations } from "vuex";

export default {
  data() {
    return {
      isLoading: false,
    };
  },

  created() {
    this.listar();
  },
  
  computed: {
    ...mapState('contratosAluguelVencidosStore', {
      contratosVencidos(state) { return state.listaContratosVencidos }
    }),

    tooltipQuantidadeContratosIsVisible() {
      return this.contratosVencidos.length > 0;
    },
    quantidadeContratos() {
      const quantidade = this.contratosVencidos.length;
      switch (quantidade) {
        case 1:
          return 'Exibindo 1 Contrato';
      
        default:
          return `Exibindo ${quantidade} Contratos`;
      }
    },
  },

  methods: {
    ...mapMutations('contratosAluguelVencidosStore', [
      'limparContratos',
    ]),
    ...mapActions('contratosAluguelVencidosStore', [
      'recuperarContratosVencidos',
    ]),

    listar() {
      this.showLoading();
      this.limparContratos();
      this.recuperarContratosVencidos()
        .then()
        .finally(() => {
          this.hideLoading();
        });
    },

    showLoading() {
      this.isLoading = true;
    },
    hideLoading() {
      this.isLoading = false;
    },
  }
};